

$( document ).ready(function() {
  
/* ------------------------------------------------------------ */

/*                             MENU                             */

/* ------------------------------------------------------------ */

    $(document).on('mouseenter', '[data-menu-trigger]', function() {
      var key = $(this).attr('data-menu-trigger');
      var $submenu = $('.sub-menu-container[data-parent="' + key + '"]');
      var $mainNav = $('.main-nav-container');
      if ($submenu.length > 0) {
        $('.sub-menu-container').not($submenu).hide();
        $submenu.show();
        $mainNav.addClass('open-menu');
      }
    });

    $(document).on('mouseleave', '.main-nav-container', function() {
      $('.sub-menu-container').hide();
      $('.main-nav-container').removeClass('open-menu');
    });


/* ------------------------------------------------------------ */

/*                         MENU HEIGHT                          */

/* ------------------------------------------------------------ */

function setHeaderHeightVar() {
  var nav = document.getElementById('navigation-container');
  var marquee = document.getElementById('marquee-container');
  var navHeight = nav ? nav.offsetHeight : 0;
  var marqueeHeight = marquee ? marquee.offsetHeight : 0;
  var totalHeight = navHeight + marqueeHeight + 12.666;
  document.documentElement.style.setProperty('--header-height', totalHeight + 'px');
}
setHeaderHeightVar();
window.addEventListener('resize', setHeaderHeightVar);

/* ------------------------------------------------------------ */

/*                        VIEW MODES PLP                        */

/* ------------------------------------------------------------ */


  $('.view-mode-option').on('click', function() {
    $('.view-mode-option').removeClass('active');
    $(this).addClass('active');
    $('body').removeClass('four-view-mode two-view-mode mix-view-mode');

    if ($(this).hasClass('four-view-mode')) {
      $('body').addClass('four-view-mode');
    } else if ($(this).hasClass('two-view-mode')) {
      $('body').addClass('two-view-mode');
    } else if ($(this).hasClass('mix-view-mode')) {
      $('body').addClass('mix-view-mode');
  }
  
  });

/* ------------------------------------------------------------ */

/*                     EDITORIAL POSITIONS                      */

/* ------------------------------------------------------------ */

  var aligns = ['align-left', 'align-right'];
  var images = ['image-small', 'image-medium', 'image-large', 'image-extralarge'];

  var combinaciones = [];
  aligns.forEach(function(align) {
    images.forEach(function(image) {
      combinaciones.push({ align: align, image: image });
    });
  });

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]];
    }
    return array;
  }

  combinaciones = shuffle(combinaciones);

  $('.block-blog-article').each(function(index) {
    var combinacion = combinaciones[index % combinaciones.length];
    $(this)
      .removeClass('align-left align-right image-small image-medium image-large image-extralarge')
      .addClass(combinacion.align)
      .addClass(combinacion.image);
  });

/* ------------------------------------------------------------ */

/*                        HOMEPAGE GRID                         */

/* ------------------------------------------------------------ */


  $('.grid-button').on('click', function () {
    $('.grid-button').removeClass('active');
    $(this).addClass('active');
    if ($(this).hasClass('button-off')) {
      $('.homepage-grid').addClass('hidden');
    } else {
      $('.homepage-grid').removeClass('hidden');
    }
  });

/* ------------------------------------------------------------ */

/*                        CART CHECKBOX                        */

/* ------------------------------------------------------------ */

$('.cart-attribute__field input[type="checkbox"]').on('change', function() {
  if ($(this).is(':checked')) {
    $('.checkout-container').removeClass('inactive');
  } else {
    $('.checkout-container').addClass('inactive');
  }
});


/* ------------------------------------------------------------ */

/*                        NEW IN LAST UNITS                        */

/* ------------------------------------------------------------ */


$(document).on('click', '.status-option', function() {
  var status = '';
  if ($(this).hasClass('new-in')) status = 'new in';
  if ($(this).hasClass('last-units')) status = 'last units';
  if (!status) return;

  if ($(this).hasClass('active')) {
    $(this).removeClass('active');
    $('.product-grid .product-card, .product-grid-related .product-card').show();
    return;
  }

  $('.status-option').removeClass('active');
  $(this).addClass('active');

  $('.product-grid .product-card, .product-grid-related .product-card').hide();

  $('.product-grid .product-card, .product-grid-related .product-card').filter(function() {
    var value = $(this).data('availability');
    return value && value.toLowerCase() === status;
  }).show();
});




/* ------------------------------------------------------------ */

/*                        SEARCH TRIGGER                        */

/* ------------------------------------------------------------ */

  $('.search-trigger').on('click', function () {
    $('.search-form').removeClass('hidden');
    $(this).addClass('hidden');
  });

/* ------------------------------------------------------------ */

/*                        FOOTER TRIGGER                        */

/* ------------------------------------------------------------ */

$(function () {
  const $footer = $(".footer-section-center .sub-menu-footer");

  function toggleFooterMenus() {
    $(window).width() <= 820 ? $footer.hide() : $footer.show();
  }

  toggleFooterMenus();
  $(window).on("resize", toggleFooterMenus);

  // Click en títulos
  $(document).on("click", ".footer-section-center .nav-title", function (e) {
    if ($(window).width() <= 820) {
      e.preventDefault();
      const $submenu = $(this).siblings(".sub-menu-footer");
      $footer.not($submenu).slideUp();
      $submenu.slideToggle();
    }
  });
})


/* ------------------------------------------------------------ */

/*                       FEATURED PRODUCTS MENU                 */

/* ------------------------------------------------------------ */



var $activeNavLink = $('.sub-sub-menu-container[data-parent="product-categories"] .nav-link[data-collection-handle].active-link').first();
if ($activeNavLink.length) {
  var handle = $activeNavLink.data('collection-handle');
  $('.featured-collection-group').removeClass('active');
  $('.featured-collection-group[data-collection-handle="' + handle + '"]').addClass('active');
} else {
  $('.featured-collection-group').removeClass('active');
  $('.sub-sub-menu-featured-content .featured-collection-group').first().addClass('active');
}

$(document).on('mouseenter', '.sub-sub-menu-container[data-parent="product-categories"] .nav-link[data-collection-handle]', function() {
  var handle = $(this).data('collection-handle');
  $('.sub-sub-menu-container[data-parent="product-categories"] .nav-link[data-collection-handle]').not($(this)).removeClass('active');
  $(this).addClass('active');
  $('.featured-collection-group').not('[data-collection-handle="' + handle + '"]').removeClass('active');
  $('.featured-collection-group[data-collection-handle="' + handle + '"]').addClass('active');
  console.log('Mouse enter', handle);
});



/* ------------------------------------------------------------ */

/*                            MOBILE MENU                       */

/* ------------------------------------------------------------ */

  $('.main-nav-mobile-trigger').on('click', function () {
    $('#mobile-menu-wrapper').toggleClass('open');
    $('body').toggleClass('open-submenu-mobile no-scroll');
  });

/* ------------------------------------------------------------ */

/*                  MOBILE MENU SUBMENU TOGGLE                  */

/* ------------------------------------------------------------ */

$(document).on('click', '.mobile-main-link', function(e) {
  $('.mobile-main-link').removeClass('nav-li-active');
  $(this).toggleClass('nav-li-active');
  var $link = $(this);
  var title = $link.text().trim();
  var handle = title.toLowerCase().replace(/[^a-z0-9]+/g, '-');
  var $submenu = $('.mobile-submenu[data-parent="' + handle + '"]');
  if ($submenu.length) {
    e.preventDefault();
    $('.mobile-submenu').not($submenu).removeClass('open');
    $submenu.toggleClass('open');
    $('#mobile-menu-submenus').addClass('open');
  } else {
    $('#mobile-menu-submenus').removeClass('open');
    $('.mobile-submenu').removeClass('open');
  }
});


/* ------------------------------------------------------------ */

/*                    FILTERS MOBILE TOGGLE                     */

/* ------------------------------------------------------------ */

$(document).on('click', '.filter-title', function(e) {
  $(this).find('span').toggle();
  $('body').toggleClass('open-filters no-scroll');
  $('.filter-options-container').toggleClass('open');
});


/* ------------------------------------------------------------ */

/*                       SWIPER SLIDER ARTICLES                 */

/* ------------------------------------------------------------ */


  var swiperArticles = null;
  function initOrDestroySwiperArticles() {
    if (window.innerWidth < 820) {
      if (!swiperArticles) {
        swiperArticles = new Swiper(".swiper-articles", {
          speed: 400,
          grabCursor: true,
          loop: true,
          centeredSlides: true,
          slidesPerView: "auto",
          spaceBetween: 20,
          grabCursor: true,
        });
      }
    } else {
      if (swiperArticles) {
        swiperArticles.destroy(true, true);
        swiperArticles = null;
      }
    }
  }
  initOrDestroySwiperArticles();
  window.addEventListener('resize', initOrDestroySwiperArticles);


/* ------------------------------------------------------------ */

/*                       SWIPER SLIDER ARTICLES                 */

/* ------------------------------------------------------------ */
  


var $sliderContainer = $('.slider-container .swiper-wrapper');
var slideCount = $sliderContainer.children('.swiper-slide').length;

var swiperOptions = {
  speed: 400,
  grabCursor: true,
  loop: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 20,
  grabCursor: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    820: {
      spaceBetween: 300,
    }
  }
};


  if (slideCount > 2) {
    swiperOptions.loop = false;
    swiperOptions.initialSlide = 1;
  }

  const productSwiper = new Swiper('.slider-container', swiperOptions);

/* ------------------------------------------------------------ */

/*                       PRODUCT CARE POP-UP                   */

/* ------------------------------------------------------------ */

  $(document).on('click', '.product-care', function() {
    $('.size-specs-pop-up').show();
    $('html').addClass('pop-up-open no-scroll');
  });

  $(document).on('click', '.size-specs-pop-up-close, .pop-up-overlay', function() {
    $('.size-specs-pop-up').hide();
    $('html').removeClass('pop-up-open no-scroll');
  });


/* ------------------------------------------------------------ */

/*                       LEGAL CONTENT                          */

/* ------------------------------------------------------------ */

  // Apply span wrapping only to paragraphs inside .legal-content
  const legalContent = document.querySelector(".legal-content");
  if (legalContent) {
    const paragraphs = legalContent.querySelectorAll("p");
    
    paragraphs.forEach(p => {
      const brElements = p.querySelectorAll("br");
      
      brElements.forEach(br => {
        const textNode = br.nextSibling;
        
        if (textNode && textNode.nodeType === 3) { // text node
          const span = document.createElement("span");
          span.className = "legal-detail-text";
          span.textContent = textNode.textContent;
          p.replaceChild(span, textNode);
        }
        
        // Remove the br element
        br.remove();
      });
    });
  }

/* ------------------------------------------------------------ */

/*                       COUNTDOWN TIMER                        */

/* ------------------------------------------------------------ */

  // Initialize countdown timers for hero text sections
  function initCountdownTimers() {
    const heroTextElements = document.querySelectorAll('.hero-text[data-countdown-date]');
    
    heroTextElements.forEach(element => {
      const dateString = element.getAttribute('data-countdown-date');
      if (dateString && dateString.trim()) {
        startCountdown(element, dateString);
      }
    });
  }

  function startCountdown(element, dateString) {
    // Parse the date string (expected format: mm-dd-yyyy hh:mm)
    const dateTimeParts = dateString.trim().split(' ');
    
    // Handle both old format (mm-dd-yyyy) and new format (mm-dd-yyyy hh:mm)
    let dateParts, hour = 23, minute = 59;
    
    if (dateTimeParts.length === 1) {
      // Old format: mm-dd-yyyy (default to 23:59)
      dateParts = dateTimeParts[0].split('-');
    } else if (dateTimeParts.length === 2) {
      // New format: mm-dd-yyyy hh:mm
      dateParts = dateTimeParts[0].split('-');
      const timeParts = dateTimeParts[1].split(':');
      hour = parseInt(timeParts[0]) || 23;
      minute = parseInt(timeParts[1]) || 59;
    } else {
      return; // Invalid format
    }
    
    if (dateParts.length !== 3) return;
    
    const month = parseInt(dateParts[0]) - 1; // JavaScript months are 0-indexed
    const day = parseInt(dateParts[1]);
    const year = parseInt(dateParts[2]);
    
    // Create target date in California timezone (Pacific Time)
    // Use proper timezone handling for California (America/Los_Angeles)
    const targetDate = new Date(year, month, day, hour, minute, 59);
    
    // Check if there's a countdown-timer-text span (user wants to show both text and countdown)
    const countdownTextSpan = element.querySelector('.countdown-timer-text');
    const showBothTextAndCountdown = countdownTextSpan !== null;
    
    function updateCountdown() {
      // Get current time in California timezone using proper timezone conversion
      const now = new Date();
      
      // Get California current time using proper timezone offset calculation
      // First, get UTC time
      const utc = now.getTime() + (now.getTimezoneOffset() * 60000);
      
      // Get California time offset (PST = UTC-8, PDT = UTC-7)
      // Use Intl.DateTimeFormat to determine if it's currently DST in California
      const californiaFormatter = new Intl.DateTimeFormat('en-US', {
        timeZone: 'America/Los_Angeles',
        timeZoneName: 'short'
      });
      
      const californiaTimeString = californiaFormatter.format(now);
      const isDST = californiaTimeString.includes('PDT'); // PDT = Daylight Time, PST = Standard Time
      const californiaOffset = isDST ? -7 : -8; // PDT is UTC-7, PST is UTC-8
      
      // Calculate California time
      const californiaTime = new Date(utc + (californiaOffset * 3600000));
      
      // For target date, we need to create it as if it were in California timezone
      // Since targetDate was created in local time, we need to adjust it to California time
      const targetUTC = targetDate.getTime() - (targetDate.getTimezoneOffset() * 60000);
      const targetInCalifornia = new Date(targetUTC + (californiaOffset * 3600000));
      
      const timeDiff = targetDate.getTime() - californiaTime.getTime();
      
      if (timeDiff <= 0) {
        // Event has ended - hide the entire hero-text element
        element.style.display = 'none';
        return;
      }
      
      const days = Math.floor(timeDiff / (1000 * 60 * 60 * 24));
      const hours = Math.floor((timeDiff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
      
      const countdownHTML = `
        <div class="countdown-timer">
          <div class="countdown-segment">
            <span class="countdown-number">${days}</span>
            <span class="countdown-label">D</span>
          </div>
          <div class="countdown-segment">
            <span class="countdown-number">${hours.toString().padStart(2, '0')}</span>
            <span class="countdown-label">H</span>
          </div>
          <div class="countdown-segment">
            <span class="countdown-number">${minutes.toString().padStart(2, '0')}</span>
            <span class="countdown-label">M</span>
          </div>
          <div class="countdown-segment">
            <span class="countdown-number">${seconds.toString().padStart(2, '0')}</span>
            <span class="countdown-label">S</span>
          </div>
        </div>
      `;
      
      if (showBothTextAndCountdown) {
        // Keep the original text and append countdown
        const originalText = countdownTextSpan.outerHTML;
        element.innerHTML = originalText + countdownHTML;
      } else {
        // Replace entirely with countdown
        element.innerHTML = countdownHTML;
      }
    }
    
    // Update immediately and then every second
    updateCountdown();
    setInterval(updateCountdown, 1000);
  }

  // Initialize countdown timers when document is ready
  initCountdownTimers();

  });